import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { PlacesService } from './places.service';

export const Ng1PlacesModule = angular
  .module('control-room.shared.services.places', [])
  .factory('crPlacesService', downgradeInjectable(PlacesService));
